<template>
    <div class="app">
        <jycheader></jycheader>
        <div class="deta_box">
            <div class="detail-top-nav">
                <div class="nav-item-box">
                    <p>首页</p>
                    <img src="../../assets/image/iocn/shownetter.png">
                    <p>{{detailData.oneCategoryName || detailData.pCategoryName}}</p>
                    <img
                        v-if="detailData.twoCategoryName"
                        src="../../assets/image/iocn/shownetter.png"
                    >
                    <p v-if="detailData.twoCategoryName">{{detailData.twoCategoryName}}</p>
                    <img src="../../assets/image/iocn/shownetter.png">
                    <p>{{detailData.categoryName}}</p>
                </div>
            </div>
            <div class="deta_head">
                <div class="data_head">
                    <div class="data_headbox">
                        <div class="data_headimgs">
                            <div class="boxmoing">
                                <magnifier :imgList="imglist"></magnifier>
                            </div>
                        </div>
                        <div class="data_headation" style="height:auto">
                            <div class="data_headationtop dis" v-if="is_discount != 3 && is_discount != 4 ">
                                <p>{{detailData.name}}</p>
                                <p v-if="detailData.goodsComponent1" style="margin-left:10px">({{detailData.goodsComponent1}})</p>
                                <p v-if="detailData.goodsComponent1 && detailData.goodsSize" style="margin:10px 10px 0 10px"> / </p>
                                <p v-if="detailData.goodsSize">{{detailData.goodsSize}}</p>
                                <!-- <span>{{item.test}}</span> -->
                            </div>
                            <!--普通价 抬头-->
                            <div
                                class="not-discount"
                                v-if="detailData.shopType == 1"
                            >
                                <div v-if="is_discount != 3 && is_discount != 4">
                                    <div class="discount">
                                    <div class="shop_tip">
                                        <div>温馨提示：</div>
                                        <div>不支持七天无理由</div>
                                        <div>生鲜蔬果下单后,我们将快速配送发货</div>
                                        <div>请及时留意您的宝贝到达情况，为保障您的权益，请在确认商品完好后在签收.</div>
                                    </div>
                                    </div>
                                    <div class="data_headationmin2 eatsn-box" style="width:775px;background: #F7F7F9;padding:0 16px;height:176px;margin-top:20px">
                                        <div class="dis-between" style="width:100%">
                                            <div class="detail-headation-left">
                                                <div v-if="detailData.goodsType == 2">
                                                    <div class="eatsn-p" style="color:#666666;height:auto">积&nbsp;&nbsp;分&nbsp;&nbsp;价<span class="eatsn-p2"></span><span class="eatsn-col">{{detailData.integral}}</span><span style="color:#FB573D;margin-left:8px">分</span>
                                                        <span style="border:none;margin-top: 0.8rem;color: #646464;font-size: 14px;text-decoration: line-through;margin-left:20px">￥{{detailData.price}}</span>
                                                        <span style="text-decoration:none;margin-left:50px">已&nbsp;&nbsp;&nbsp;&nbsp;售：{{detailData.salesSum}}</span>
                                                    </div>
                                                    <div class="eatsn-p" style="color:#666666;margin-top:16px">规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格<span class="eatsn-p2" style="color:#FF6B30">{{detailData.goodsSize}}</span></div>
                                                </div>
                                                <div v-else>
                                                    <div class="eatsn-p" style="color:#666666;height:auto">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格<span class="eatsn-p2">￥</span><span class="eatsn-col">{{detailData.price}}</span>
                                                    <span style="text-decoration:none;margin-left:50px">已&nbsp;&nbsp;&nbsp;&nbsp;售：{{detailData.salesSum}}</span></div>
                                                    <div class="eatsn-p" style="color:#666666;margin-top:16px">规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格<span class="eatsn-p2" style="color:#FF6B30">{{detailData.goodsSize}}</span></div>
                                                </div>
                                                <div class="eatsn-p" style="color:#666666;margin-top:16px">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠<span class="eatsn-p2" style="color:#FF6B30">暂无优惠</span></div>
                                            </div>
                                            <div class="detail-headation-right">
                                                <!-- <div class="saveline"></div> -->
                                                <img v-if="detailData.isAttention" @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin45678.png" />
                                                <img v-else @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin456789.png" />
                                            </div>
                                        </div>
                                        <div class="eatsn-p" style="color:#666666;margin-top:16px">服&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务<span class="eatsn-p2" style="color:#000000">由917厨房网发货，提供“全城送”及售后服务。手指点点，美食连连。</span></div>
                                    </div>
                                </div>
                                <!-- 名小吃 (商品信息模块) -------------------------------------------------------------------------------->
                                <div v-if="is_discount == 3 || is_discount == 4">
                                    <div class="eatsn-title">{{detailData.name}}<span style="margin-left:30px">{{detailData.goodsSize}}</span></div>
                                    <div class="dis" style="margin:20px 0 12px 0">
                                        <div class="eatsn-p">主&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;料：<span style="color:#000000">{{detailData.mainIngredient}}</span></div>
                                        <div class="eatsn-p">菜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;系：<span style="color:#000000">{{detailData.twoCategoryName}}</span></div>
                                        <div class="eatsn-p">制作方法：<span style="color:#000000">{{detailData.productionMethods}}</span></div>
                                    </div>
                                    <div class="dis" style="margin:0 0 33px 0">
                                        <div class="eatsn-p">文&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;化：<span style="color:#000000">{{detailData.categoryDescription}}</span></div>
                                    </div>

                                    <div class="eatsn-box">
                                        <div class="dis-between">
                                            <div class="eatsn-p" style="color:#666666;margin-top:16px">价&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格<span class="eatsn-p2">￥</span><span class="eatsn-col">{{detailData.price}}</span></div>
                                            <img v-if="detailData.isAttention" @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin45678.png" />
                                            <img v-else @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin456789.png" />
                                        </div>
                                        <div class="eatsn-p" style="color:#666666;margin-top:4px">优&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;惠<span class="eatsn-p2" style="color:#FF6B30">暂无优惠</span></div>
                                        <div class="eatsn-p" style="color:#666666;margin-top:16px">服&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务<span class="eatsn-p2" style="color:#000000">由917厨房网发货，提供“全城送”及售后服务。手指点点，美食连连。</span></div>
                                        <div class="eatsn-p dis" style="color:#666666;margin-top:16px">温馨提示<div class="eatsn-p2" style="color:#000000">生鲜蔬果下单后，我们将快速配送发货<br>不支持七天无理由退货</div></div>    
                                    </div>

                                    <div class="eatsn-xian"></div>
                                    <div class="dis-between">
                                        <div class="eatsn-p" style="width:37%">店&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名：<span style="color:#333333">{{detailData.shopName}}</span></div>
                                        <div class="eatsn-p" style="width:37%">电&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话：<span style="color:#333333">{{detailData.shopPhone}}</span></div>
                                        <div class="eatsn-p" style="width:25%">已&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;售：<span style="color:#333333">{{detailData.salesSum}}</span></div>
                                    </div>
                                    <div class="eatsn-p" style="margin-top:13px">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：<span style="color:#333333">{{detailData.shopAddress}}</span></div>
                                    <div class="eatsn-xian"></div>

                                </div>
                                <!---------------------------------------------------------------------------------->

                                <div class="" style="width: 100%;margin-top: 30px;" v-if="detailData.goodsType != 2">
                                    <!-- <div
                                        class="data_minunit"
                                        style="margin-top: 0;"
                                    >
                                        数&nbsp;&nbsp;&nbsp;量
                                    </div> -->
                                    <div class="details-num">选择数量</div>
                                    <div class="detail-num-box">
                                        <span @click="reds">-</span>
                                        <input
                                            v-model="buyNum"
                                            type="text"
                                        >
                                        <span @click="adds">+</span>
                                    </div>
                                </div>
                            </div>
                            <!--折扣价 抬头-->
                            <div
                                v-else
                                class="discount"
                            >
                                <div class="pric_tip">原价{{detailData.price}}元！现厨房网抢购价{{detailData.discountPrice}}元！</div>
                                <div class="shop_tip">
                                    <div>温馨提示：</div>
                                    <div>不支持七天无理由</div>
                                    <div>生鲜蔬果下单后,我们将快速配送发货</div>
                                    <div>请及时留意您的宝贝到达情况，为保障您的权益，请在确认商品完好后在签收.</div>
                                </div>
                                <div class="data_headationmin" style="width:775px;background: #F7F7F9;padding:0 16px;height:146px;margin-top:20px">
                                    <div class="detail-headation-left">
                                        <!-- <div
                                            v-if="detailData.goodsType == 2"
                                            class="o_price"
                                            style="margin-bottom:5px"
                                        >
                                            <span style="font-size: 20px;">积分价</span>
                                            <span style="text-decoration:none">{{detailData.integral}}分</span>
                                        </div>
                                        <div
                                            v-else
                                            class="o_price"
                                            style="margin-bottom:5px"
                                        >
                                            <span style="font-size: 20px;">价&nbsp;&nbsp;&nbsp;格</span>
                                            <span>￥{{detailData.price}}</span>
                                        </div> -->
                                        <div class="eatsn-p" style="color:#666666;height:auto">折&nbsp;&nbsp;扣&nbsp;&nbsp;价<span class="eatsn-p2" style="color:#FB573D">￥</span>
                                            <span v-if="detailData.banJia > 0" class="eatsn-col">{{detailData.banJia}}</span>
                                            <span v-else class="eatsn-col">{{detailData.discountPrice}}</span>
                                            <span style="border:none;margin-top: 0.8rem;color: #646464;font-size: 14px;text-decoration: line-through;margin-left:20px">￥{{detailData.price}}</span><!--v-if="detailData.goodsType == 2"-->
                                            <span style="text-decoration:none;margin-left:50px">已&nbsp;&nbsp;&nbsp;&nbsp;售：{{detailData.salesSum}}</span>
                                        </div>
                                        <div class="eatsn-p" style="color:#666666;margin-top:16px">规&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;格<span class="eatsn-p2" style="color:#FF6B30">{{detailData.goodsSize}}</span></div>
                                        <div class="eatsn-p" style="color:#666666;margin-top:16px">服&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务<span class="eatsn-p2" style="color:#000000">由917厨房网发货，提供“全城送”及售后服务。手指点点，美食连连。</span></div>
                                    </div>
                                    <div class="detail-headation-right">
                                        <img v-if="detailData.isAttention" @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin45678.png" />
                                        <img v-else @click="addAttention(detailData.id,detailData.categoryId)" class="eatsn-img" style="cursor:pointer" src="../../assets/image/img/xin456789.png" />
                                    </div>
                                </div>
                            </div>

                            <div class="buy-btn-box" v-if="detailData.categoryType != 2">
                                <div
                                    class="lkbuy-btn"
                                    @click="buyGoods"
                                >
                                <!-- <img
                                        src="../../assets/image/img/详情页/lkbuy_img.png"
                                        alt=""
                                    > -->
                                    立即购买</div>
                                <div
                                    v-if="detailData.goodsType != 2 && detailData.categoryType != 4 && detailData.categoryType != 5"
                                    class="add-shopcart"
                                    @click="join_shopcart(detailData.id)"
                                >
                                <img
                                    src="../../assets/image/img/详情页/asdfg.png"
                                    alt=""
                                >
                                加入购物车</div>
                            </div>

                            <div v-if="is_discount == 3 || is_discount == 4" style="height:58px"></div>
                            <div v-else style="height:80px"></div>
                        </div>
                    </div>
                </div>
            </div>

            <!---->
            <eat-snack v-if="is_discount == 3 && is_eatsnack" :parent-name="shopGoodsGroupListObj" @childFn="closeEatSnackPopup"></eat-snack>
            
            <!---->
            <eat-snack-locality v-if="is_discount == 4 && is_eatsnack" :parent-name="shopGoodsGroupListObjLocality" @childFn="closeEatSnackLocalityPopup"></eat-snack-locality>
            
            <!---->
            <div v-if="is_discount != 3 && is_discount != 4" class="deta_main" style="background-color: #F1F1F1;">
                <div style="width:100%;" class="dis-cen">
                    <div style="width:1200px;height:380px;background: #FFFFFF;margin-top:46px">
                        <div class="dis details-rxcp">
                            <div class="tab-p-col" :class="tabValueNew == 1?'tab-p-col2':''" @click="tabValueNewClick(1, '')">本店供应</div>
                            <div class="details-xian" style="background:#A2ADA6;width:3px"></div>
                            <div class="tab-p-col" :class="tabValueNew == 2?'tab-p-col2':''" @click="tabValueNewClick(2, '')">热销产品</div>
                        </div>
                        <div class="dis-between">
                            <img v-if="is_but_status !== 1" @click="upClick" style="width:49px;height:63px;margin:auto 0 auto 20px" src="../../assets/image/img/2.png" />
                            <div v-else style="width:49px;height:63px;margin:auto 0 auto 20px"></div>
                            
                            <div v-if="allHenData.length > 0" class="main_con_three_table" style=" display: flex;padding:10px 20px 20px 20px">
                                <div class="marketlistbut2" v-for="(item8,index8) in allHenData" :key="index8">
                                    <div style="margin:0 10px;cursor: pointer;" @click="getdetailData(item8.id)">
                                        <img style="width:180px;height:180px;border-radius: 10px;border: 1px solid #E1F0E7" :src="item8.cover" />
                                        <div class="hnel" style="width:180px;margin:10px 0 5px 0">{{item8.name}}</div>
                                        <!-- <div v-if="item8.goodsSize" class="good-size-p2">{{item8.goodsSize}}</div><div v-else class="good-size-p2">无规格</div> -->
                                        <div class="all-com-p" style="margin: 5px 0 12px 0;font-size:15px">
                                            <span v-if="item8.goodsComponent1">{{item8.goodsComponent1}}</span>
                                            <span v-if="item8.goodsComponent1 && item8.goodsSize"> / </span>
                                            <span v-if="item8.goodsSize">{{item8.goodsSize}}</span>
                                        </div>
                                        <div v-if="!item8.goodsComponent1 && !item8.goodsSize" style="height:25px"></div>


                                        <div v-if="is_discount == 1" class="details-price-base" style="margin: 0 0"><span style="font-size:12px">￥</span><span>{{item8.discountPrice}}</span><span style="font-size:10px;text-decoration: line-through;color: #999999;margin-left:10px">￥</span><span style="font-size:10px;text-decoration: line-through;color: #999999;">{{item8.price}}</span></div>
                                        <div v-else-if="is_discount == 2" class="details-price-base" style="margin: 0 0"><span style="font-size:12px">积分价</span><span style="margin-left:6px">{{item8.integral}}</span><span style="font-size:10px;text-decoration: line-through;color: #999999;margin-left:10px">￥</span><span style="font-size:10px;text-decoration: line-through;color: #999999">{{item8.price}}</span></div>
                                        <div v-else class="details-price-base" style="margin: 0 0"><span style="font-size:12px">￥</span>{{item8.price}}</div>
                                        <div style="height:20px"></div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="main_con_three_table" style="display:flex;justify-content:center;line-height:305px;">加载中...</div>
                            <img v-if="is_but_status !== 2 && is_page_count" @click="downClick" style="width:49px;height:63px;margin:auto 20px auto 0" src="../../assets/image/img/1.png" />
                            <div v-else style="width:49px;height:63px;margin:auto 0"></div>
                        </div>
                    </div>
                </div>
                <div class="deta_mainbox">
                    <div class="deta_maincent">
                        <div class="detail-hotFooter-box">
                            <!---->
                            <div style="background-color:#ffffff;box-shadow: 0px 10px 28px 0px rgba(0, 0, 0, 0.08);">
                                <div class="detail-hotFooter-nav" style="background-color:#ffffff;padding:12px 20px;height:auto;">
                                    <div
                                        class="hotFooter-nav"
                                        style="text-align:center;color:#434343;font-size: 18px;background-color:#F5F8FF;width:100%;display: flex;flex-direction: column;justify-content: center;align-items: center;"
                                        @click="changeHot(index)"
                                        :class="{hotactive:footerIndex==index}"
                                        v-for="(item,index) in hotfooterNav"
                                        :key="index"
                                    >
                                        <div class="dis">
                                            <div style="margin-left:36px">{{item}}</div>
                                            <img style="width:30px;height:30px;margin:auto 10px" src="../../assets/image/jiantou.gif" />
                                        </div>
                                    </div>
                                </div>
                                <div v-if="matchData.length > 0">
                                    <div style="padding:0 8px" v-for="(item2, index2) in matchData" :key="index2">
                                        <div class="hotfooter-item marketlistbut2" style="cursor: pointer;padding: 0 8px" @click="routeListClick(item2.categoryID, item2.twoCategoryID)">
                                            <img
                                                style="width:190px;height:190px;margin:auto 0;border: 1px solid #E1F0E7;border-radius: 10px;"
                                                :src="item2.cover"
                                                alt=""
                                            >
                                            <div class="hotfooter-content">
                                                <div class="hotfoods-left hnel2">
                                                    <p>{{item2.categoryName}}</p>
                                                </div>
                                                <div class="hotfoods-right">￥{{item2.discountPrice}}<span style="margin-left:10px" v-if="item2.goodsSize">元/{{item2.goodsSize}}</span></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else style="min-height:900px"></div>
                            </div>
                        </div>
                        <div class="deta_maincentB">
                            <div class="foods-detailInfo-box">
                                <div class="foods-detailInfo-left">
                                    <div
                                        class="foodsInfo-title"
                                        @click="proDetail"
                                        :class="{detailnav_active:infoFlag == 1}"
                                    >图片详情</div>
                                    <div
                                        class="foods-evaluation"
                                        @click="proComment"
                                        :class="{detailnav_active:infoFlag == 2}"
                                    >评价({{totalCountShow}})</div>
                                    <div
                                        class="foods-evaluation"
                                        @click="proInfo"
                                        :class="{detailnav_active:infoFlag == 3}"
                                    >商品信息</div>
                                </div>
                                <!-- <div class="foods-detailInfo-right">加入购物车</div> -->
                            </div>

                            <!-- <div class="detail-activebanner">
								<img src="../../assets/image/img/首页/active_detail.png" alt="">
							</div> -->
                            <div
                                v-if="infoFlag == 1"
                                class="detail-content"
                            >
                                <el-image
                                    :src="detailData.detailImg"
                                    lazy
                                ></el-image>
                                <!-- <img :src="detailData.detailImg" alt=""> -->
                            </div>
                            <div
                                v-else-if="infoFlag == 2"
                                class="user-comments"
                            >
                                <div style="height:20px"></div>
                                <div v-if="listData.length > 0">
                                    <div class="dis-between" v-for="(item3, index3) in listData" :key="index3" style="margin-bottom:40px">
                                        <div class="dis">
                                            <img v-if="item3.avatar" style="width:40px;height:40px;" :src="item3.avatar" />
                                            <img v-else style="width:40px;height:40px;" src="../../assets/image/iocn/eaticon2.png" />
                                            <div class="eatsn-ping-p">{{item3.user_name}}</div>
                                        </div>
                                        <div class="eatsn-wid" style="width:73%">
                                            <div class="dis-between">
                                                <div class="dis">
                                                    <div class="dis">
                                                        <div v-for="(item5, index5) in item3.stars" :key="index5" style="margin:auto 0"><img class="eatsn-img-icon" src="../../assets/image/iocn/eaticon4.png" /></div>
                                                        <div v-if="item3.no_stars > 1" style="margin:auto 0"><img v-for="item6 in item3.no_stars" :key="item6" class="eatsn-img-icon" src="../../assets/image/iocn/eaticon3.png" /></div>
                                                        <img v-else-if="item3.stars == 4" class="eatsn-img-icon" src="../../assets/image/iocn/eaticon3.png" />
                                                    </div>
                                                    <div style="margin-left:27px">
                                                        <div v-if="item3.stars == 5" class="eatsn-ping-p2">非常满意</div>
                                                        <div v-else-if="item3.stars == 4" class="eatsn-ping-p2">满&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;意</div>
                                                        <div v-else-if="item3.stars == 1" class="eatsn-ping-p2">极&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;差</div>
                                                        <div v-else class="eatsn-ping-p2">一&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;般</div>
                                                    </div>
                                                    
                                                </div>
                                                <div class="eatsn-ping-p2">{{item3.add_date}}</div>
                                            </div>
                                            <div class="eatsn-ping-p2" style="color: #333333;">{{item3.description}}</div>
                                            <div class="dis">
                                                <img v-for="(item4, index4) in item3.v_imglist" :key="index4" class="eatsn-img-icon2" :src="item4" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div v-else style="text-align:center">
                                    <img style="width:316px;height:320px;margin:200px auto" src="../../assets/image/img/newimg/pinglun.png" />
                                </div>
                                <div class="dis-end eatsn-pagin" style="margin:0 0 30px 0" v-if="listData.length > 0">
                                    <el-pagination
                                        background
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-sizes="[9, 20, 30, 40]"
                                        :page-size="PagePingSize"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="totalPingCount">
                                    </el-pagination>
                                </div>
                            </div>
                            <!---->
                            <div
                                v-else-if="infoFlag == 3"
                                class="detail-content"
                            >
                            <div class="details-info-wid">
                                <div class="details-info-wid-p">品牌名称：917厨房网</div>
                                <div class="dis">
                                    <div class="details-info-wid-p">商品名称：{{detailData.name}}</div>
                                    <div class="details-info-wid-p">商品编号：{{detailData.id}}</div>
                                    <!-- <div class="details-info-wid-p">商铺地址：{{detailData.shopAddress}}</div> -->
                                    <!-- <div class="details-info-wid-p" v-if="detailData.categoryType == 4">制作方式：{{detailData.productionMethods}}</div> -->
                                    <!-- <div class="details-info-wid-p">商品类别：{{detailData.twoCategoryName}}</div> -->
                                </div>
                            </div>
                                <el-image
                                    :src="detailData.detailImg"
                                    lazy
                                ></el-image>
                                <!-- <img :src="detailData.detailImg" alt=""> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="deta_mainbtombox"></div>
            </div>
        </div>
        <!------------------>
  
        <div
            class="reg-popup-bac req-popup-pos"
            v-if="is_playCar_popup"
        ></div>
        <div
            class="req-popup-pos reg-popup-wid dis-cen"
            v-if="is_playCar_popup"
            @click="closePopupClick"
        >
            <div class="reg-popup-box">
                <div class="dis-between">
                    <div style="width:29px;height:29px"></div>
                    <div style="text-align: center;">
                        <img style="width:160px;height:135px;" src="../../assets/image/img/newimg/gouwuche.png" />
                        <div style="margin:20px 0;font-size: 20px;font-family: PingFang SC;font-weight: bold;color: #333333;">新商品已加入到购物车中</div>
                    </div>
                    <img style="width:29px;height:29px" @click="closePopupClick" src="../../assets/image/img/newimg/closeccc.png" />
                </div>
                <div class="dis-between" style="padding:14px 24px;width:100%;height:108px;background: #F1F1F1;">
                    <img style="width:80px;height:80px" :src="detailData.cover" />
                    <div>
                        <div style="width:376px;font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #333333;">{{detailData.name}}</div>
                        <div class="all-com-p" style="margin: 12px 0 0 0;font-size:15px">
                            <span v-if="detailData.goodsComponent1">{{detailData.goodsComponent1}}</span>
                            <span v-if="detailData.goodsComponent1 && detailData.goodsSize"> / </span>
                            <span v-if="detailData.goodsSize">{{detailData.goodsSize}}</span>
                        </div>
                    </div>
                    <div style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #333333;">x{{buyNum}}</div>
                </div>
                <div class="dis-cen" style="width:100%">
                    <div class="dis" style="margin-top:23px">
                        <div class="details-info-wid-botton" @click="gouCarClick">查看购物车</div>
                        <div class="details-info-wid-botton2" @click="gouIndexClick">继续购物</div>
                    </div>
                </div>

            </div>
        </div>
        
        <el-backtop :bottom="100">
            <div style="{
		        height: 100%;
		        width: 100%;
		        border-radius: 100px;
		        background-color: #f2f5f6;
		        box-shadow: 0 0 6px rgba(0,0,0, .12);
		        text-align: center;
		        line-height: 40px;
		        color: #569516;
		      }">
                <i class="el-icon-upload2"></i>
            </div>
        </el-backtop>
        <jycfooter></jycfooter>
    </div>
</template>

<script>
    // 引入放大镜组件
    import Magnifier from '../../components/magnifier.vue';
    import eatSnack from './eatSnack.vue'
    import eatSnackLocality from './eatSnackLocality.vue'
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"
    import { GetDiscountGood, GetJiFenShopGoodList, GetShopGoodListByCIDList, GetEvaluationByShopGoodsID } from '../../api/discount';
    const token = '';
    const that = this;
    export default
    {
        components:
        {
            Magnifier,
            jycheader,
            jycfooter,
            eatSnack,
            eatSnackLocality
        },
        watch:
        {
            "$route"()
            {
                this.is_discount = this.$route.query.is_discount || 0;
            }
        },
        data()
        {
            return {
                is_wximg: false,
                addressFlag: false,
                imglist: [],
                infoFlag: 1,
                searchName: '',
                footerIndex: 0,
                // hotfooterNav: [ "热销产品", "热门关注" ],
                hotfooterNav:["猜你喜欢"],
                // hotfooterNav2:["看了再看"],
                buyNum: 1,
                message: 0,
                detailData: '',
                addressIndex: -1,
                addressList: [],
                el_rate: 5,
                is_discount: 0,
                // +-------------------------
                commentlist: [], // 评论列表
                is_playCar_popup: false,
                allHenData: [],
                tabValueNew: 1,
                PageNo: 1,
                pageNumValue: 1,
                pageCountAll: 0,
                matchData: [],
                is_but_status: 1,
                is_page_count: '',
                // +------------------------
                newCategoryID: 0,
                newPageNo: 1,
                is_eatsnack: false,
                shopGoodsGroupListObj: {},
                shopGoodsGroupListObjLocality: {},
                listData: [],
                totalCountShow: 0,
                currentPage: 1,
                PagePingSize: 9,
                totalPingCount: 0
            }
        },
        mounted()
        {
            window.scroll(0, 0)
            this.is_wximg = true
            let detailId = this.$route.query.id;
            this.is_discount = this.$route.query.is_discount;
            this.getdetailData( detailId );
            this.token = localStorage.getItem( 'token' );
        },
        methods:
        {
            closeWxClick() {
                this.is_wximg = false
            },
            gouIndexClick() {
                this.$router.push({path: '/'})
            },
            gouCarClick(){
                this.$router.push({path: '/shopCart'})
            },
            closePopupClick() {
                this.is_playCar_popup = false
            },
            chooseAddress( index, id )
            { //选择收货地址
                this.addressIndex = index;
            },
            close_infobox()
            { //关闭商品信息框
                this.addressFlag = false;
            },
            buyGoods()
            { //立即购买
                if ( this.token == '' || this.token == null )
                {
                    this.$message(
                    {
                        message: '登录后才可以下单购买!',
                        type: 'warning'
                    } )
                }
                else
                {
                    let v_minute_price = 0

                    if (this.is_discount == 1 || this.is_discount == 2) {
                        v_minute_price = Number(this.detailData.discountPrice) * 100
                        if (Number(this.detailData.discountPrice) == Number(this.detailData.price)) v_minute_price = Number(this.detailData.price) * 100
                    } else {
                        v_minute_price = Number(this.detailData.price) * 100
                    }
                    if (this.detailData.banJia > 0) v_minute_price = this.detailData.banJia * 100

                    let totalPrice = this.detailData.price * this.buyNum;
                    let goodsList = [
                    {
                        id: 0,
                        shopGoodsId: this.detailData.id,
                        shopId: this.detailData.shopId,
                        name: this.detailData.name,
                        cover: this.detailData.cover,
                        price: this.detailData.price,
                        num: this.buyNum,
                        shopType: this.detailData.shopType,
                        shopTypeName: this.detailData.shopTypeName,
                        allPrice: totalPrice.toFixed( 2 ),
                        v_minute_price: v_minute_price,
                        v_summation: v_minute_price * this.buyNum,
                        v_discountPrice: '',
                        goodsType: this.detailData.goodsType,
                        integral: this.detailData.integral,
                        banJia: this.detailData.banJia,
                        goodsSize: this.detailData.goodsSize,
                        categoryType: this.detailData.categoryType,
                        deliveryStartAt: this.detailData.deliveryStartAt

                    } ]
                    goodsList[0]['v_integralSum'] = 0
                    if (this.is_discount == 3 || this.is_discount == 4) goodsList[0]['shopLngLat'] = this.detailData.shopLngLat
                    // if (this.is_discount == 1) {
                    //     goodsList[0]['discountPrice'] = this.detailData.discountPrice
                    //     goodsList[0].v_discountPrice = this.detailData.discountPrice * 100
                    // } else {
                    //     goodsList[0]['discountPrice'] = this.detailData.discountPrice // [补丁] 普通商品也要带折扣价
                    // }
                    goodsList[0]['discountPrice'] = this.detailData.discountPrice
                    goodsList[0].v_discountPrice = this.detailData.discountPrice * 100

                    if (this.detailData.banJia > 0) goodsList[0].v_discountPrice = this.detailData.banJia * 100


                    localStorage.setItem( 'goodInfo', JSON.stringify( goodsList ) )
                    this.$router.push(
                    {
                        path: '/orderinfo'
                    } )
                }
            },
            join_shopcart( id )
            { //加入购物车
                if ( this.token == '' || this.token == null )
                {
                    this.$message(
                    {
                        message: '登录后才可以加入购物车!',
                        type: 'warning'
                    } )
                }
                else
                {
                    let params = {
                        ShopProductId: id,
                        CategoryType: this.detailData.categoryType,
                        Num: this.buyNum,
                        ShopId: this.detailData.shopId
                    }
                    this.$api.product.joinshopCart( params ).then( res =>
                    {
                        if ( res.data.code == 0 )
                        {
                            this.$message(
                            {
                                message: "加入购物车成功，快去购物车查看吧!",
                                type: "success"
                            } )
                            this.is_playCar_popup = true
                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: "warning"
                            } )
                        }
                    } )
                }
            },
            addAttention( id, categoryId )
            { //添加关注
                if ( this.token == '' || this.token == null )
                {
                    this.$message(
                    {
                        message: '登录后才可以关注商品哦!',
                        type: 'warning'
                    } )
                }
                else
                {
                    let params = {
                        ShopGoodId: id,
                        CategoryId: categoryId
                    }
                    this.$api.product.clickSave( params ).then( res =>
                    {
                        if ( res.data.code == 0 )
                        {
                            if (!this.detailData.isAttention) {
                                this.$message(
                                {
                                    message: '关注成功!',
                                    type: 'success'
                                } )
                            } else {
                                this.$message(
                                {
                                    message: '关注已取消!',
                                    type: 'success'
                                } )
                            }
                            this.detailData.isAttention = !this.detailData.isAttention
                        }
                        else
                        {
                            this.$message(
                            {
                                message: res.data.message,
                                type: 'warning'
                            } )
                        }
                    } )
                }
            },
            routeListClick(categoryID, twoCategoryID) {
                if (this.detailData.shopType == 1) {
                    // 普通
                    this.$router.push({
                        path:'/productlist',
                        query:{
                            categoryId:categoryID,
                            twoCategoryId:twoCategoryID
                        }
                    })
                } else if (this.detailData.shopType == 2) {
                    // 折扣
                    this.$router.push({
                        path:'/discount_list',
                        query:{
                            TwoCategoryId: twoCategoryID,
                            categoryId:categoryID
                        }
                    })
                }
            },
            upClick() {
                if (this.PageNo > 1) {
                    this.PageNo = this.PageNo - 1
                } else {
                    this.is_but_status = 1
                    return
                }
                this.tabValueNewClick(this.tabValueNew, 1)
                this.is_but_status = 0

                if (this.PageNo == 1) this.is_but_status = 1
            },
            downClick() {
                if (this.PageNo < this.pageCountAll) {
                    this.PageNo = this.PageNo + 1
                } else {
                    this.is_but_status = 2
                    return
                }
                this.tabValueNewClick(this.tabValueNew, 1)
                this.is_but_status = 0
            },
            tabValueNewClick(val, num) {
                if (!num) {
                    this.PageNo = 1 
                    this.is_but_status = 1
                }
                this.tabValueNew = val
                this.allHenData = []
                if (this.is_discount == 1) {
                    let v_inputData = {PageNo: this.PageNo,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                    if (val == 2) v_inputData.Params['SalesSumDesc'] = true
                    this.$api.product.GetDiscountShopGoodList(v_inputData).then((res) => {
                        this.allHenData = res.data.result.data
                        this.pageCountAll = res.data.result.totalCount / 5
                        if (this.PageNo == res.data.result.pageCount && res.data.result.pageCount !== 1) this.is_but_status = 2
                    })
                } else if (this.is_discount == 2) {
                    let v_inputData = {PageNo: this.PageNo,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                    if (val == 2) v_inputData.Params['SalesSumDesc'] = true
                    GetJiFenShopGoodList(v_inputData).then((res) => {
                        this.allHenData = res.data.result.data
                        this.pageCountAll = res.data.result.totalCount / 5
                        if (this.PageNo == res.data.result.pageCount && res.data.result.pageCount !== 1) this.is_but_status = 2
                    })
                } else if (this.is_discount == 3) {
                    let v_inputData = {PageNo: this.PageNo,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                    if (val == 2) v_inputData.Params['SalesSumDesc'] = true
                    // this.$api.product.GetMMCShopGoodList2(v_inputData).then((res) => {
                    //     this.allHenData = res.data.result.data
                    //     this.pageCountAll = res.data.result.totalCount / 5
                    //     if (this.PageNo == res.data.result.pageCount && res.data.result.pageCount !== 1) this.is_but_status = 2
                    // })
                } else if (this.is_discount == 4) {
                    let v_inputData = {PageNo: this.PageNo,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                    if (val == 2) v_inputData.Params['SalesSumDesc'] = true
                    // ...
                } else {
                    let v_inputData = {PageNo: this.PageNo,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                    if (val == 2) v_inputData.Params['SalesSumDesc'] = true
                    this.$api.product.goodsList(v_inputData).then((res) =>{
                        this.allHenData = res.data.result.data
                        this.pageCountAll = res.data.result.totalCount / 5
                        if (this.PageNo == res.data.result.pageCount && res.data.result.pageCount !== 1) this.is_but_status = 2
                    })
                }
            },
            getdetailData( id )
            {
                this.tabValueNew = 1
                this.proDetail()
                //获取详情页数据 categoryType = 1 普通、categoryType = 2 折扣、categoryType = 3 积分
                window.scrollTo(0, 0)
                this.imglist = []
                this.$loading();
                if ( this.is_discount == 1 )
                {
                    GetDiscountGood( id ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.detailData = res.data.result;
                            this.imglist = res.data.result.imgList.split( ',' );
                            let v_inputData = {PageNo: 1,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                            this.$api.product.GetDiscountShopGoodList(v_inputData).then((res) => {
                                this.allHenData = res.data.result.data
                                this.pageCountAll = res.data.result.totalCount / 5
                                if (res.data.result.pageCount > 1) this.is_page_count = 1
                            })
                            
                            this.newCategoryID = res.data.result.categoryId
                            let v_inputData2 = {PageNo: 1,PageSize: 10,Params: {CategoryID: res.data.result.categoryId}}
                            GetShopGoodListByCIDList(v_inputData2).then((res) => {
                                this.matchData = res.data.result.data
                            })

                            let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                            GetEvaluationByShopGoodsID(inputData2).then((res) => {
                                this.totalCountShow = res.data.result.totalCount
                            })
                        }
                    } )
                }
                else if (this.is_discount == 2) {
                    this.$api.product.GetJiFenGood( id ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.detailData = res.data.result;
                            this.imglist = res.data.result.imgList.split( ',' );
                            let v_inputData = {PageNo: 1,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                            GetJiFenShopGoodList(v_inputData).then((res) => {
                                this.allHenData = res.data.result.data
                                this.pageCountAll = res.data.result.totalCount / 5
                                if (res.data.result.pageCount > 1) this.is_page_count = 1
                            })

                            let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                            GetEvaluationByShopGoodsID(inputData2).then((res) => {
                                this.totalCountShow = res.data.result.totalCount
                            })
                        }
                    } )
                }
                else if (this.is_discount == 3) {
                    
                    this.$api.product.GetMMCGood( id ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.detailData = res.data.result;
                            this.imglist = res.data.result.imgList.split( ',' );
                            this.shopGoodsGroupListObj = {shopGoodsGroupList: this.detailData.shopGoodsGroupList, ShopId: this.detailData.shopId, ShopGoodsId: this.detailData.id}
                            this.is_eatsnack = true
                            // // 拉取全部商品接口
                            // let v_inputData = {PageNo: 1,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                            // this.$api.product.GetMMCShopGoodList2(v_inputData).then((res) =>{
                            //     this.allHenData = res.data.result.data
                            //     this.pageCountAll = res.data.result.totalCount / 5
                            //     if (res.data.result.pageCount > 1) this.is_page_count = 1
                            // })
                            // console.log(res.data.result.categoryId)
                            // this.newCategoryID = res.data.result.categoryId
                            // let v_inputData2 = {PageNo: 1,PageSize: 10,Params: {CategoryID: res.data.result.categoryId}}
                            // GetShopGoodListByCIDList(v_inputData2).then((res) => {
                            //     this.matchData = res.data.result.data
                            // })

                            let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                            GetEvaluationByShopGoodsID(inputData2).then((res) => {
                                this.totalCountShow = res.data.result.totalCount
                            })
                        }
                    } )
                }
                else if (this.is_discount == 4) {
                    
                    this.$api.product.GetBDXCGood( id ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.detailData = res.data.result;
                            this.imglist = res.data.result.imgList.split( ',' );
                            this.shopGoodsGroupListObjLocality = {shopGoodsGroupList: this.detailData.shopGoodsGroupList, ShopId: this.detailData.shopId, ShopGoodsId: this.detailData.id}
                            this.is_eatsnack = true
                            // // 拉取全部商品接口
                            // let v_inputData = {PageNo: 1,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                            // this.$api.product.GetMMCShopGoodList2(v_inputData).then((res) =>{
                            //     this.allHenData = res.data.result.data
                            //     this.pageCountAll = res.data.result.totalCount / 5
                            //     if (res.data.result.pageCount > 1) this.is_page_count = 1
                            // })
                            // console.log(res.data.result.categoryId)
                            // this.newCategoryID = res.data.result.categoryId
                            // let v_inputData2 = {PageNo: 1,PageSize: 10,Params: {CategoryID: res.data.result.categoryId}}
                            // GetShopGoodListByCIDList(v_inputData2).then((res) => {
                            //     this.matchData = res.data.result.data
                            // })

                            let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                            GetEvaluationByShopGoodsID(inputData2).then((res) => {
                                this.totalCountShow = res.data.result.totalCount
                            })
                        }
                    } )
                } else {
                    this.$api.product.goodsDetail( id ).then( res =>
                    {
                        this.$loading().close();
                        if ( res.data.code == 0 )
                        {
                            this.detailData = res.data.result;
                            this.imglist = res.data.result.imgList.split( ',' );
                            // 拉取全部商品接口
                            let v_inputData = {PageNo: 1,PageSize: 5,Params: {ShopId: this.detailData.shopId}}
                            this.$api.product.goodsList(v_inputData).then((res) =>{
                                this.allHenData = res.data.result.data
                                this.pageCountAll = res.data.result.totalCount / 5
                                if (res.data.result.pageCount > 1) this.is_page_count = 1
                            })
                            this.newCategoryID = res.data.result.categoryId
                            let v_inputData2 = {PageNo: 1,PageSize: 10,Params: {CategoryID: res.data.result.categoryId}}
                            GetShopGoodListByCIDList(v_inputData2).then((res) => {
                                this.matchData = res.data.result.data
                            })

                            let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                            GetEvaluationByShopGoodsID(inputData2).then((res) => {
                                this.totalCountShow = res.data.result.totalCount
                            })
                        }
                    } )
                }
            },
            proDetail()
            { //切换商品详情
                this.currentPage = 1
                this.infoFlag = 1;
            },
            proComment()
            { //切换商品评论
                this.infoFlag = 2;
                let inputData2 = {PageNo: this.currentPage, PageSize: this.PagePingSize, Params: {ShopGoodsId: this.detailData.id}}
                GetEvaluationByShopGoodsID(inputData2).then((res) => {
                    this.listData = res.data.result.data
                    for (let i = 0; i < this.listData.length; i++) {
                        let a = this.listData[i].imglist
                        this.listData[i]['v_imglist'] = a.split(',')
                        let b = this.listData[i].stars
                        this.listData[i]['no_stars'] =  5 - Number(b)
                    }
                    this.totalCountShow = res.data.result.totalCount
                    this.totalPingCount = res.data.result.totalCount
                })
            },
            proInfo()
            {
                this.currentPage = 1
                this.infoFlag = 3;
            },
            handleSizeChange(val) {
                this.currentPage = 1
                this.proComment()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.proComment()
            },
            handleNodeClick( data )
            {
                // console.log(data);
            },
            changeHot( index )
            { //点击选择热销产品和热门关注
                this.footerIndex = index;

                // 猜你喜欢 +--------------------------
                // this.newPageNo = this.newPageNo + 1
                this.matchData = []
                let v_inputData2 = {PageNo: this.newPageNo, PageSize: 10,Params: {CategoryID: this.newCategoryID}}
                GetShopGoodListByCIDList(v_inputData2).then((res) => {
                    // if (res.data.result.data.length > 0) {
                        this.matchData = res.data.result.data
                        // if (res.data.result.data.length < 10) {
                        //     this.newPageNo = 0
                        //     this.$message({type: 'info',message: '没有更多数据了'})
                        // }
                    // } else {
                    //     this.matchData = res.data.result.data
                    //     this.newPageNo = 0
                    //     this.$message({type: 'info',message: '没有更多数据了'})
                    // }
                    
                })

            },
            //点击增加减少
            adds()
            {
                this.buyNum++
            },
            reds()
            {
                if ( this.buyNum <= 0 )
                {

                }
                else
                {
                    this.buyNum--
                    if (this.buyNum == 0) this.buyNum = 1
                }
            },
            closeEatSnackPopup(id) {
                this.is_discount = 3
                this.is_eatsnack = false
                this.getdetailData( id )
            },
            closeEatSnackLocalityPopup(id) {
                this.is_discount = 4
                this.is_eatsnack = false
                this.getdetailData( id )
            }

        },
    }
</script>

<style scoped="scoped">
    @import "./details.css";
    .details-p{font-size: 16px;color: #98A39C;}.details-p2{font-size: 16px;color: #333333;}
    .tab-p-col{color:#434343;cursor: pointer;}.tab-p-col2{color:#11D165;font-weight: 600;}
    .eatsn-pagin >>> .el-pagination.is-background .el-pager li:not(.disabled).active {background-color: #11D165 !important}
 .main_con_three_table {
        width: 100%;
        padding: 0 20px 20px 20px;
        box-sizing: border-box;
        /* margin-bottom: 40px; */
        /* margin-top: 15px; */
        overflow: auto;
    }
.reg-popup-bac {
        width: 100%;
        height: 100vh;
        background-color: #000000;
        opacity: 0.8;
    }

    .req-popup-pos {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }

    .reg-popup-wid {
        width: 100%;
        height: 100vh;
    }

    .reg-popup-box {
        width: 648px;
        height: 420px;
        background-color: #ffffff;
        /* border-radius: 2rem; */
        padding: 24px;
        box-sizing: border-box;
    }

    .detail-submit {
        width: 7.125rem;
        height: 1.875rem;
        background: #F5F5F5;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        text-align: center;
        line-height: 1.75rem;
        color: #737373;
        font-size: 0.75rem;
        cursor: pointer;
        margin: 1.25rem auto 0 auto;
    }

    .add-address {
        width: 100%;
        text-align: right;
        color: #37A115;
        font-size: 0.75rem;
        margin-top: 0.75rem;
        cursor: pointer;
    }

    .addressactive {
        border-color: #37A115 !important;
    }

    .detail-address-item>p {
        color: #CC9977;
        font-size: 12px;
        cursor: pointer;
        margin-top: 0.2rem;
    }

    .detaill-address {
        color: #333333;
        font-size: 14px;
        margin-top: 0.25rem;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .detail-userinfo-box p:nth-of-type(2) {
        font-size: 0.875rem;
        margin-left: 0.625rem;
    }

    .detail-userinfo-box {
        display: flex;
        align-items: center;
        color: #333333;
        font-size: 1rem;
    }

    .detail-address-item {
        width: 21.875rem;
        height: 5rem;
        border: 1px solid #CCCCCC;
        border-radius: 5px;
        padding: 0.5rem 0 0.5rem 0.5rem;
    }

    .detail-address-box {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .buyinfo-price-box span {
        color: #B4B4B4;
        font-size: 12px;
        text-decoration: line-through;
    }

    .buyinfo-price-box p {
        color: #C80000;
        font-size: 22px;
        margin-left: 0.625rem;
        margin-right: 0.3125rem;
    }

    .buyinfo-price-box {
        display: flex;
        align-items: center;
        color: #999999;
        font-size: 16px;
        margin-top: 2.5rem;
    }

    .goods-info-right>p {
        color: #737373;
        font-size: 16px;
        font-weight: 400px;
        padding-right: 6.25rem;
    }

    .buy-goods-infobox>img {
        width: 13rem;
        height: 13rem;
        margin-right: 1.25rem;
    }

    .buy-goods-infobox {
        width: 100%;
        height: 13rem;
        display: flex;
        align-items: center;
    }

    .buyInfo-tips p:nth-of-type(2) {
        font-size: 1.75rem;
        cursor: pointer;
    }

    .buyInfo-tips {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #191919;
        font-size: 16px;
        font-weight: 400;
    }

    .goods-buyInfo-content {
        width: 48.125rem;
        height: 27.5rem;
        background-color: #FFFFFF;
        border-radius: 10px;
        border: 9px solid #B3B3B3;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 0 1.25rem 0 1.25rem;
    }

    .goods-buyInfo-box {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.1);
        z-index: 10;
    }

    .goods-info {
        width: 75rem;
        margin: auto;
        padding-left: 5rem;
    }

    .saveline {
        position: absolute;
        top: 0.625rem;
        left: 0;
        width: 1px;
        height: 3.125rem;
        background-color: #CCCCCC;
    }

    .sell-count p {
        color: #37A115;
        margin-left: 0.625rem;
    }

    .sell-count {
        color: #999999;
        font-size: 1.375rem;
        font-weight: 400;
        display: flex;
        align-items: center;
    }

    .sell-countbox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1rem;
    }

    .detail-content img {
        width: 100%;
        height: 100%;
    }

    .detail-content {
        width: 790px;
        height: auto;
        margin: 1.25rem auto 0 auto;
    }

    .detail-activebanner {
        margin-top: 3.4375rem;
    }

    .detail-activebanner,
    .detail-activebanner img {
        width: 100%;
        height: 14.1875rem;
    }

    .foodsinfos {
        margin-top: 0.625rem;
    }

    .foodsinfo-box:nth-of-type(1) {
        margin-left: 0;
    }

    .foodsinfo-box {
        margin-left: 6.25rem;
    }

    .foods-infobox {
        display: flex;
        align-items: flex-start;
        color: #4D4D4D;
        font-size: 18px;
        font-weight: 400;
        margin-top: 1.25rem;
        /* padding-left: 3.125rem; */
    }

    .foods-brand {
        width: 100%;
        color: #4D4D4D;
        font-size: 18px;
        font-weight: 400;
        margin-top: 1.875rem;
        /* padding-left: 3.125rem; */
    }

    .foods-detailInfo-right {
        width: 5.75rem;
        height: 1.75rem;
        text-align: center;
        color: #FFFFFF;
        line-height: 1.75rem;
        background-color: #DF3033;
        cursor: pointer;
        font-size: 14px;
    }

    .detailnav_active {
        color: #FFFFFF !important;
        /* background-color: #E4393C; */
        background-color:#FF6B30
    }

    .foodsInfo-title,
    .foods-evaluation {
        width: 160px;
        height: 100%;
        font-size: 16px;
        text-align: center;
        line-height: 2.5rem;
        cursor: pointer;
    }

    .foods-detailInfo-left {
        display: flex;
        align-items: center;
    }

    .foods-detailInfo-box {
        width: 100%;
        height: 2.6875rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        /* border-bottom: 3px solid #E4393C; */
    }

    .hotfoods-right {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FF4949;
        line-height: 34px;
        margin-bottom:20px
    }

    /* .hotfoods-left p {
        color: #9A9A9A;
        font-weight: 400;
        font-size: 12px;
    } */

    /* .hotfoods-left span {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        background-color: #E4393C;
        margin-right: 6px;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 1.25rem;
        text-align: center;
        border-radius: 50%;
    } */

    .hotfoods-left {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #434343;
        line-height: 24px;
        margin:17px 0
    }

    /* .hotfooter-content {
        margin-top: 0.625rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 1.25rem 0 0.625rem;
        margin-bottom: 1.875rem;
    } */

    .hotfooter-item {
        width: 100%;
        height: auto;
        /* text-align: center; */
        margin-top:20px;
        border-bottom:1px solid #f1f1f1
    }

    .hotactive {
        color: #000000 !important;
        /* background-color: #FFFFFF; */
        background-color: #F7F7F7;
    }

    .hotFooter-nav {
        width: 50%;
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 2.6875rem;
        cursor: pointer;
    }

    .detail-hotFooter-nav {
        width: 100%;
        height: 2.6875rem;
        background-color: #F7F7F7;
        /* border-bottom: 1px solid #E4393C; */
        display: flex;
        margin-bottom: 1.875rem;
    }

    .detail-hotFooter-box {
        width: 224px;
        /* min-height: 38.125rem; */
        margin-top: 15px;
        background-color: #FFFFFF;
        /* border: 1px solid #F7F7F7; */
    }

    .detail-type-title {
        color: #4D4D4D;
        height: 2.375rem;
        text-align: center;
        font-weight: 400;
        font-size: 16px;
        line-height: 2.375rem;
        border-bottom: 1px solid #DDDDDD;
    }

    .search-btn {
        width: 3rem;
        height: 1.5625rem;
        margin: 1.25rem auto 0 auto;
        background-color: #F6F6F6;
        font-size: 16px;
        color: #4D4D4D;
        text-align: center;
        line-height: 1.5625rem;
        border-radius: 5px;
        cursor: pointer;
    }

    .detail-search-name input {
        width: 6.875rem;
        height: 1.25rem;
        outline: none;
        background: #FFFFFF;
        border: 1px solid #F7F7F7;
        margin-left: 0.625rem;
        padding-left: 0.625rem;
        color: #4D4D4D;
    }

    .detail-search-name {
        color: #4D4D4D;
        font-size: 14px;
        font-weight: 400;
    }

    .detail-search-name {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0.625rem;
    }

    .detail-search-title {
        text-align: center;
        color: #4D4D4D;
        font-size: 16px;
        line-height: 2.5rem;
        font-weight: 400;
        width: 100%;
        background-color: #F7F7F7;
        height: 2.5rem;
    }

    .Ingredients-item p {
        color: #C80000;
        font-size: 14px;
        margin-top: 1.25rem;
    }

    .Ingredients-item {
        width: 20%;
        height: 100%;
        text-align: center;
    }

    .Ingredients-content-box {
        width: 75rem;
        height: 12.5rem;
        display: flex;
        margin: 1.875rem auto 0 auto;
    }

    .Ingredients-title p {
        width: 10rem;
        height: 100%;
        color: #FFFFFF;
        font-size: 20px;
        background-color: #E4393C;
        text-align: center;
        line-height: 2.5rem;
    }

    .Ingredients-title {
        width: 75rem;
        margin: auto;
        background-color: #FFFFFF;
        height: 2.6875rem;
        border-bottom: 3px solid #E4393C;
        margin-top: 1.25rem;
    }

    .recom-item-price {
        color: #C80000;
        font-size: 14px;
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    .recom-item-name {
        color: #656565;
        font-size: 14px;
        font-weight: 400;
    }

    .recom-item {
        width: 100%;
        text-align: center;
    }

    .recommend-box {
        width: 13.4275rem;
        padding-top: 1.25rem;
        margin-left: 1rem;
    }

    .recommend-box p {
        color: #656565;
        font-size: 16px;
        font-weight: 400;
    }

    .recom-line {
        width: 4rem;
        height: 1px;
        background-color: #CCCCCC;
    }

    .recom-tips {
        display: flex;
        align-items: center;
        margin-bottom: 0.875rem;
    }

    .buy-btn-box img {
        margin-right: 4px;
    }

    .add-shopcart {
        background: #262626;
        color: #FFFFFF;
    }

    .lkbuy-btn {
        background: #FF6B30;
        /* background: #D9161C; */
        /* border: 1px solid #C80000; */
        color: #ffffff;
        margin-right: 3.125rem;
    }

    .lkbuy-btn,
    .add-shopcart {
        width: 10.125rem;
        line-height: 40px;
        /* border-radius: 5px; */
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .buy-btn-box {
        display: flex;
        align-items: center;
        margin-top: 3rem;
        /* padding-left: 8.125rem; */
    }

    .detail-num-box input {
        width: 64px;
        height: 40px;
        text-align: center;
        outline: none;
        /* margin: 0 0.625rem; */
        border:none;
        font-size: 24px;
        border-top: 1px solid #777777;
        border-bottom: 1px solid #777777;
    }

    .detail-num-box span {
        display: inline-block;
        width: 40px;
        height: 40px;
        text-align: center;
        line-height: 38px;
        font-size: 25px;
        border: 1px solid #777777;
        cursor: pointer;
    }

    .detail-num-box {
        display: flex;
        align-items: center;
        margin-top:17px
        /* margin-left: 1rem; */
    }

    .sell-num {
        color: #999999;
        font-size: 16px;
        font-weight: 400;
        margin-top: 6px;
    }

    .detail-sellnum {
        margin: auto;
    }

    .detail-sellnum,
    .detail-sellnum img {
        width: 2.8125rem;
        height: 3.3125rem;
        cursor: pointer;
    }

    .detail-headation-right {
        height: auto;
        position: relative;
        padding-left: 1rem;
        margin-right: 0.625rem;
        text-align: center;
        /* display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column; */
    }

    .detail-headation-left {
        padding-top: 0.625rem;
    }

    .detail-headation-left>p {
        color: #999999;
        margin-top: 0.625rem;
        font-size: 16px;
        font-weight: 400;
    }

    .discount-price span {
        display: inline-block;
        width: 1.375rem;
        height: 1.375rem;
        text-align: center;
        line-height: 1.25rem;
        color: #37A115;
        margin-left: 1rem;
        font-size: 12px;
        border: 1px solid #37A115;
    }

    .discount-price {
        color: #999999;
        font-size: 24px;
        font-weight: 400;
        margin-top: 0.625rem;
    }

    .detail-price-box p span {
        font-size: 1rem;
        color: #C80000;
    }

    .detail-price-box span {
        display: inline-block;
        margin-top: 0.4rem;
        color: #B4B4B4;
        font-size: 12px;
        text-decoration: line-through;
    }

    .detail-price-box p {
        color: #C80000;
        font-size: 28px;
        margin: 0 0.625rem;
    }

    .detail-price-box {
        color: #999999;
        font-size: 24px;
        display: flex;
        font-weight: 400;
        align-items: center;
    }

    .nav-item-box img {
        width: 6px;
        height: 8px;
        margin: 0 0.625rem;
    }

    .nav-item-box {
        display: flex;
        width: 75rem;
        height: 1.75rem;
        margin: auto;
        font-size: 12px;
        color: #737373;
        align-items: center;
    }

    .detail-top-nav {
        width: 100%;
        height: 1.75rem;
        background-color: #F2F2F2;
    }

    .boxmoing {
        width: 100%;
        height: 100%;
    }

    .deta_box {
        width: 100%;
        height: 100%;
    }

    .deta_head {
        width: 100%;
        height: auto;
        background-color: #FFFFFF;
        display: flex;
        justify-content: center;
    }

    .deta_main {
        width: 100%;
        height: 100%;
        /* background-color: #F1F1F1; */
    }

    .data_head {
        width: 75rem;
        height: 100%;
    }

    .data_headbox {
        width: 100%;
        /* height: 34.375rem; */
        height: auto;
        display: flex;
        margin-top: 30px;
    }

    .data_headimgs {
        height: 26.25rem;
        width: 21.875rem;
    }

    .data_headation {
        width: 46.875rem;
        height: 27.8125rem;
        margin-left: 1.875rem;
    }

    .data_headationtop {
        margin-bottom: 0.625rem;
    }

    .data_headationtop p {
        font-size: 1.875rem;
        font-weight: 400;
        color: #737373;
        margin-top: 0.625rem;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        /* line-height: 50px; */
    }

    .data_headationtop span {
        display: inline-block;
        font-size: 12px;
        font-weight: 400;
        color: #37A115;
        margin-top: 0.625rem;
        /* line-height: 34px; */
        /* margin-left: 0.7rem; */
    }

    .data_headationmin {
        width: 100%;
        /* height: 8.125rem; */
        background: url(../../assets/image/img/详情页/detail_bg.png);
        /* margin-top: 30px; */
        display: flex;
        justify-content: space-between;
        /* padding: 0 0.625rem 0.625rem 0.625rem; */
        background: #F7F7F7;
        box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
    }

    .data_headsmintop {
        width: 30.875rem;
        height: 2.375rem;
        background-color: #479764;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 34px;
    }

    .data_headsmintop p {
        margin-left: 2rem;
    }

    .data_headsminbomt {
        width: 494px;
        height: 36px;
        border-top: 1px dashed #999999;
        background: #EDEDED;
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 2rem;
    }

    .data_headsminbomt p {
        margin-left: 2rem;
    }

    .data_headtopmins {
        width: 100%;
        height: 4.875rem;
        display: flex;
        justify-content: space-between;
    }

    .data_headtopmins p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 5rem;
        margin-left: 2rem;
    }

    .data_headtopmins span {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #C80000;
        line-height: 72px;
    }

    .data_minunit p {
        font-size: 18px;
        margin-left: 1rem;
    }

    .data_minunit {
        font-size: 22px;
        font-weight: 400;
        color: #999999;
        display: flex;
        align-items: center;
        padding-left: 0.625rem;
    }

    .data_minadd {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        margin-top: 1rem;
    }

    .data_minaddnumber {
        width: 7.5rem;
        display: flex;
    }

    .data_minaddnumber input {
        outline: none;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #a3a3a3;
        line-height: 72px;
        margin-left: 0.5rem;
        padding-left: 0.2rem;
    }

    .data_minaddnumber p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .data_minadds {
        display: flex;
    }

    .data_minaddst {
        width: 5.8125rem;
        height: 1.5rem;
        border: 1px solid #BFBFBF;
        text-align: center;
        margin: 0.5rem;
        cursor: pointer;
    }

    .data_minaddst p {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin: -1.3rem 1rem;
    }

    .data_minaddsbtn {
        width: 8.4375rem;
        height: 2.6875rem;
        background: #D83939;
        border-radius: 5px;
        text-align: center;
        cursor: pointer;
    }

    .data_minaddsbtn p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin: -2rem -0.8rem;
    }

    .data_minaddbox {
        width: 3rem;
        height: 2.0625rem;
        border: 1px solid #CECECE;

    }

    .data_minsadd {
        width: 1.3125rem;
        height: 1rem;
        background: #E6E6E6;
        text-align: center;
        cursor: pointer;
        margin-left: 0.2rem;
    }

    .data_minsaddimgsA {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -145px -402px;
        width: 21px;
        height: 16px;
    }

    .data_minsaddimgsB {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -183px -402px;
        width: 21px;
        height: 16px;
    }

    .data_minaddstimgA {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -264px -405px;
        width: 10px;
        height: 10px;
        margin: 0.5rem 0.2rem;
    }

    .data_minaddstimgB {
        background: url('../../assets/image/iocn/iocnfont.png') no-repeat -218px -397px;
        width: 26px;
        height: 26px;
        margin: 0.5rem 1rem;
    }

    .data_minadds p {
        margin-left: 1rem;
    }

    .data_minprompt {
        margin-top: 1.5rem;
    }

    .data_minprompt h4 {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 34px;
    }

    .data_minprompt p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #D83939;
    }

    .data_minprompt span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 34px;
    }

    .deta_mainbtombox {
        width: 100%;
        height: 1px;
        background-color: #E7E7E7;
        margin-top: 2.5rem;
    }

    .deta_mainbox {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
    }

    .deta_maincent {
        width: 75rem;
        height: 100%;
        display: flex;
        justify-content: space-between;
        margin-top: 2.75rem;
        padding: 0 55px;
        background-color: #ffffff
    }

    .deta_maincentA {}

    .deta_maincentAa {
        width: 12.875rem;
        height: 8.75rem;
        background: #FFFFFF;
        border: 1px solid #F7F7F7;
    }

    .deta_maincentAb {
        width: 12.875rem;
        height: auto;
        /* min-height: 18rem; */
        background: #FFFFFF;
        margin-top: 1.5rem;
        background-color: #F7F7F7;
        padding-bottom: 0.625rem;
    }

    .deta_maincentB {
        width: 790px;
        height: 100%;
        background: #FFFFFF;
        margin-top:13px
        /* display: flex; */
        /* justify-content: center; */
    }

    .deta_maincentAa h4 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #020202;
        line-height: 20px;
        padding: 1.3rem;
    }

    .deta_maincentAalis {}

    .deta_maincentAalis td {
        width: 8.4rem;
        height: 2.75rem;
        border: 1px solid #E7E7E7;
        border-left: none;
        text-align: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        line-height: 44px;
        cursor: pointer;
    }

    .deta_maincentAalis td:hover {
        color: #069338;
    }

    .deta_maincentAalis tr td:nth-child(2) {
        border-right: none;
    }

    .deta_maincentAb h4 {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 34px;
        padding: 1.5rem;
    }

    .deta_maincentAb span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #999999;
        line-height: 34px;
        margin-left: 1rem;
    }

    .deta_maincentAbs {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .deta_maincentAbst {
        width: 12.875rem;
        height: 100%;

    }

    .deta_maincentAbstA {
        display: flex;
        width: 12.875rem;
        border-bottom: 1px solid #E2E2E2;
        margin-top: 1rem;
    }

    .deta_maincentAbstA img {
        width: 7.3125rem;
        height: 4.75rem;
    }

    .deta_maincentAbstAs {}

    .deta_maincentAbstAs p {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        margin: 0.2rem 0.5rem;
    }

    .deta_maincentAbstAs p:nth-child(2) {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ED0000;
    }

    .deta_maincentBbox h4 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
        margin: 1rem 1.5rem;
    }

    .deta_maincentBbox {
        width: 45.875rem;
        height: 100%;
        margin-top: 1rem;
    }

    .deta_maincentBbox td {
        width: 22.84375rem;
        height: 2.375rem;
        border: 1px solid #DFDFDF;
    }

    .deta_maincentBbox td p {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-left: 1rem;
        line-height: 40px;
    }

    .deta_maincentBbox td span {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
    }

    .deta_maincentBx {
        width: 100%;
        height: 9.8125rem;
        background: #F6F6F6;
        margin-top: 1.5rem;

    }

    .deta_maincentBx h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 20px;
        padding: 1.5rem 1rem;
    }

    .deta_maincentBx p {
        width: 41.75rem;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #666666;
        line-height: 20px;
        text-indent: 2em;
        padding-left: 2rem;
    }
    .details-wu{width:22px;height:22px;font-size: 14px; color:#37A115;border:1px solid #37A115;margin:auto 10px;text-align: center}
    .details-wu-p{margin:auto 10px; font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #999999;}
    .data_headationmin2 {
        width: 100%;
        /* height: 166px; */
        background: url(/img/detail_bg.fb419d78.png);
        /* margin-top: 30px; */
        /* padding: 0 0.625rem 0.625rem 0.625rem; */
        background: #F7F7F7;
        box-shadow: 0px 13px 24px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
    }
    .details-num{font-size: 16px;
font-family: PingFang SC;
font-weight: 500;
color: #646464;}
@import '../../assets/style/base.css';
</style>
<style>
    .el-rate {
        margin: 9px 0;
    }

    .el-rate i.el-rate__icon {
        font-size: 28px;
    }

    .detail-type-item .el-tree {
        width: 100%;
        background-color: #F7F7F7;
    }

    .detail-type-item .el-tree-node:nth-of-type(8) .el-tree-node__content {
        border: none;
    }

    .detail-type-item .el-tree-node__content {
        height: 1.875rem;
        padding-left: 0;
        border-bottom: 1px solid #DDDDDD;
    }

    .detail-type-item .el-tree-node__content>.el-tree-node__expand-icon {
        padding: 0.375rem 0.375rem 0.375rem 0.625rem;
    }

    .detail-type-item .el-tree-node .el-tree-node__content {
        padding-left: 0px !important;
    }

    .detail-type-item .el-tree-node__children .el-tree-node__content {
        border: none;
    }

    .detail-type-item .el-tree-node__content:nth-last-of-type(1) {
        /* border: none; */
    }

    .detail-type-item .el-tree-node__label {
        color: #666666;
        font-size: 12px;
    }
</style>